import { PartyStages } from 'services/api/getPartyStages';

// Delivery lifecycle status for SMS transport
export const SMSStatus = {
    QUEUED: 'QUEUED',
    SENDING: 'SENDING',
    SENT: 'SENT',
    FAILED: 'FAILED',
    DELIVERED: 'DELIVERED',
} as const;

// Agentic node status on SMS node
export const SMSNodeStatus = {
    QUEUED: 'QUEUED',
    SENT: 'SENT',
    USER_ENGAGED: 'USER_ENGAGED',
    USER_ABANDONED: 'USER_ABANDONED',
    AGENT_ABANDONED: 'AGENT_ABANDONED',
    COMPLETE: 'COMPLETE',
    FAILED: 'FAILED',
} as const;

// Agentic conversation state
export const SMSConversationState = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    BLOCKED_OPT_OUT: 'BLOCKED_OPT_OUT',
} as const;

// Agentic node-level failure/reason detail
export const SMSNodeSubStatus = {
    INVALID_NUMBER: 'INVALID_NUMBER',
    BLOCKED: 'BLOCKED',
    UNDELIVERABLE: 'UNDELIVERABLE',
    LANDLINE: 'LANDLINE',
    RATE_LIMITED: 'RATE_LIMITED',
    SYSTEM_ERROR: 'SYSTEM_ERROR',
    OPT_OUT: 'OPT_OUT',
} as const;

// Backward-compatible aliases while consumers migrate
export const SMSType = SMSStatus;
export const SMSNodeStatusType = SMSNodeStatus;

export type SMSStatusValue = (typeof SMSStatus)[keyof typeof SMSStatus];
export type SMSNodeStatusValue = (typeof SMSNodeStatus)[keyof typeof SMSNodeStatus];
export type SMSConversationStateValue = (typeof SMSConversationState)[keyof typeof SMSConversationState];
export type SMSNodeSubStatusValue = (typeof SMSNodeSubStatus)[keyof typeof SMSNodeSubStatus];
export type SMSStatusType = SMSStatusValue;
export type SMSNodeStatusTypeValue = SMSNodeStatusValue;

export type SMSStatistic = {
    // Queue/Pending States
    pending: number;
    queued: number;
    overDue: number;

    // In-Progress States
    sending: number;
    retrying: number;

    // Success States
    sent: number;
    delivered: number;

    // Failure States
    failed: number;
    // undelivered: number;

    // Recipient Actions
    // replied: number;

    // Network/Carrier Issues
    // carrierFiltered: number;
    // invalidNumber: number;

    // Total
    total: number;
};

export const SMSDirection = {
    OUTBOUND: 'OUTBOUND',
    INBOUND: 'INBOUND',
} as const;

export const SMSDisposition = {
    OPT_OUT: 'OPT_OUT',
    OPT_IN: 'OPT_IN',
} as const;

export type SMSDirectionType = (typeof SMSDirection)[keyof typeof SMSDirection];

export type SMSSortField = 'smsDate' | 'sentDate';

export type SMSDataType = {
    smsId: string;
    sentTime: string;
    scheduledDate: string;
    contactName: string;
    phoneNumber: string;
    messageContent: string;
    status: keyof typeof SMSStatus;
    nodeStatus?: SMSNodeStatusValue;
    conversationState?: SMSConversationStateValue;
    nodeSubStatus?: SMSNodeSubStatusValue;
    partyStage: keyof typeof PartyStages;
    contactId: string;
    crmId: string;
    overDue: boolean;
    deliveredTime?: string;
    failureReason?: string;
    carrierStatus?: string;
    messageDirection: keyof typeof SMSDirection;
    replyContent?: string;
    disposition: keyof typeof SMSDisposition;
};

// Node Type for filtering between Call and SMS
export const NodeType = {
    CALL: 'CALL',
    SMS: 'SMS',
} as const;

export type NodeTypeValue = (typeof NodeType)[keyof typeof NodeType];
